import { css, useTheme } from "@emotion/react";

import pageGridContext from "./pageGridContext";
import usePageGrid from "./usePageGrid.jsx";
import useThemeProps from "./useThemeProps.jsx";

// function PageGridDebug({ ...restProps }) {
//   const theme = useTheme();
//   const context = useContext(pageGridContext);
//   let { gridWidthPx, gapWidthPx } = context;
//   // let padding = `max(
//   //   50% - ${theme.getLength(maxWidth)} / 2,
//   //   ${theme.getLength(spacing)}
//   // )`;
//   return (
//     <div
//       css={css`
//         margin-bottom: -2rem;
//       `}
//     >
//       <pre {...restProps} css={css``}>
//         <code>{JSON.stringify(context, null, 2)}</code>
//       </pre>
//       <div
//         css={css`
//           margin-inline: auto;
//           padding-inline: ${gapWidthPx}px;
//           display: flex;
//           gap: ${gapWidthPx}px;
//           justify-content: stretch;
//           max-width: ${gridWidthPx - gapWidthPx}px;
//           & > * {
//             flex: 1 1 0;
//             background: #0001;
//             height: 2rem;
//           }
//         `}
//       >
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//         <div></div>
//       </div>
//     </div>
//   );
// }

const defaultRenderItem = ({
  item: { children, as: Component = "div" },
  // eslint-disable-next-line no-unused-vars
  meta,
  ...props
}) => <Component {...props}>{children}</Component>;

export default function PageGrid(inProps) {
  inProps = useThemeProps({ props: inProps, name: "PageGrid" });
  const theme = useTheme();
  let {
    as: Component = "div",
    renderItem: Item = defaultRenderItem,
    justify = "center",
    ...props
  } = inProps;

  let { context, ref, isSubgrid, items, rowGap, ...restProps } =
    usePageGrid(props);

  let {
    gapWidthPx,
    contentWidthPx,
    windowWidthPx,
    gridWidthPx,
    columnWidthPx,
  } = context.grid;

  return (
    <pageGridContext.Provider value={context}>
      {/* <PageGridDebug /> */}
      <Component
        ref={ref}
        css={css`
          /* position: relative; */
          display: flex;
          flex-wrap: wrap;
          gap: ${gapWidthPx}px;
          row-gap: ${theme.getLength(rowGap)};
          justify-content: ${justify};
          justify-items: center;
          @media screen {
            padding-inline: ${isSubgrid
              ? null
              : `${(windowWidthPx - contentWidthPx) / 2}px`};
          }
          @media not screen {
            padding-inline: ${isSubgrid ? null : `${gapWidthPx}px`};
          }
          width: 100%;
          box-sizing: border-box;
          /* &:after {
            content: "";
            position: absolute;
            inset-block: 0;
            inset-inline: ${isSubgrid
            ? 0
            : `${(windowWidthPx - gridWidthPx + gapWidthPx) / 2}px`};
            background-repeat: repeat-x;
            background-position: 0 0;
            background-size: ${columnWidthPx}px 100%;
            background-image: linear-gradient(
              to right,
              #0001 0,
              #0001 ${columnWidthPx - gapWidthPx}px,
              #0000 ${columnWidthPx - gapWidthPx}px,
              #0000 ${columnWidthPx}px
            );
            pointer-events: none;
          } */
        `}
        {...restProps}
      >
        {items.map((item, itemIndex) => {
          let {
            colspan,
            maxWidth,
            itemMinWidthPx,
            itemMaxWidthPx,
            itemBaseWidthPx,
            itemFlexGrow,
            itemFlexShrink,
            itemColumnCount,
          } = item;
          let meta = {
            colspan,
            maxWidth,
            itemMinWidthPx,
            itemMaxWidthPx,
            itemBaseWidthPx,
            itemFlexGrow,
            itemFlexShrink,
            isFirstItem: itemIndex === 0,
            isLastItem: itemIndex === items.length - 1,
            itemIndex: itemIndex++,
            itemCount: items.length,
            itemColumnCount,
          };
          let itemContext = {
            item,
            meta,
            grid: context.grid,
          };
          return (
            <pageGridContext.Provider key={itemIndex} value={itemContext}>
              <Item
                key={itemIndex}
                item={item}
                meta={meta}
                css={css`
                  box-sizing: border-box;
                  @media screen {
                    flex-grow: ${itemFlexGrow};
                    flex-shrink: ${itemFlexShrink};
                    width: ${itemMinWidthPx - 0.01}px;
                    min-width: min(100%, ${itemMinWidthPx - 0.01}px);
                    max-width: min(100%, ${itemMaxWidthPx - 0.01}px);
                  }
                  @media not screen {
                    width: 100%;
                  }
                  &:empty {
                    display: none;
                  }
                `}
              />
            </pageGridContext.Provider>
          );
        })}
      </Component>
    </pageGridContext.Provider>
  );
}
